import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/lib/theme";

const ThemeToggle = ({ className = "" }) => {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      onClick={toggle}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      data-testid="theme-toggle"
      title={`Switch to ${isDark ? "light" : "dark"} mode`}
      className={`relative inline-flex items-center justify-center w-10 h-10 border btn-sharp transition-all duration-300 overflow-hidden group ${className}`}
      style={{
        borderColor: "var(--border)",
        background: "var(--surface-glass)",
        color: "var(--text)",
      }}
    >
      <span
        className={`absolute inset-0 transition-opacity duration-500 ${
          isDark ? "opacity-100" : "opacity-0"
        }`}
        style={{
          background:
            "radial-gradient(circle at 30% 30%, var(--accent-blue-glow), transparent 60%)",
        }}
      />
      <Sun
        className={`absolute w-4 h-4 transition-all duration-500 ${
          isDark ? "opacity-0 rotate-90 scale-50" : "opacity-100 rotate-0 scale-100"
        }`}
        strokeWidth={1.6}
        style={{ color: "var(--accent-crimson-hover)" }}
      />
      <Moon
        className={`absolute w-4 h-4 transition-all duration-500 ${
          isDark ? "opacity-100 rotate-0 scale-100" : "opacity-0 -rotate-90 scale-50"
        }`}
        strokeWidth={1.6}
        style={{ color: "var(--accent-blue)" }}
      />
    </button>
  );
};

export default ThemeToggle;
